/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const resendMyPhoneCodeBodyPhoneNumberMin = 8;
export const resendMyPhoneCodeBodyPhoneNumberMax = 32;

export const ResendMyPhoneCodeBody = zod.object({
  phoneNumber: zod
    .string()
    .min(resendMyPhoneCodeBodyPhoneNumberMin)
    .max(resendMyPhoneCodeBodyPhoneNumberMax)
    .describe('The unverified number to re-send a code to. Must already be on the account.'),
});

export type ResendMyPhoneCodeBody = zod.input<typeof ResendMyPhoneCodeBody>;
export type ResendMyPhoneCodeBodyOutput = zod.output<typeof ResendMyPhoneCodeBody>;
